import { forwardRef, type SelectHTMLAttributes } from "react";
import { ChevronDown } from "lucide-react";
import { cn } from "../../lib/cn";

/**
 * Select — liste déroulante stylée laiton (filtres wiki, catégories HDV, tri).
 */

export interface SelectOption {
  value: string;
  label: string;
}

interface SelectProps extends Omit<SelectHTMLAttributes<HTMLSelectElement>, "onChange"> {
  options: SelectOption[];
  value: string;
  onValueChange: (v: string) => void;
  placeholder?: string;
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { options, value, onValueChange, placeholder, className, ...rest },
  ref,
) {
  return (
    <div className={cn("relative min-w-0", className)}>
      <select
        ref={ref}
        value={value}
        onChange={(e) => onValueChange(e.target.value)}
        className="h-10 w-full min-w-0 appearance-none rounded border border-iron-300/50 bg-obsidian-300 pl-3 pr-9 text-sm text-parchment-100 shadow-panel-inset transition-all duration-200 ease-brass focus:border-arcane-300/70 focus:shadow-glow-arcane focus:outline-none"
        {...rest}
      >
        {placeholder && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {options.map((o) => (
          <option key={o.value} value={o.value} className="bg-obsidian-200 text-parchment-100">
            {o.label}
          </option>
        ))}
      </select>
      <ChevronDown className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-parchment-200/45" />
    </div>
  );
});
